<div class="container-fluid mt-4">


<div *ngIf="load" class="text-center my-3">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>

<table class="table table-bordered table-striped" *ngIf="!load && orders.length">
  <thead class="table-dark">
    <tr>
      <th>ID</th>
      <th>სახელი</th>
      <th>ტელეფონი</th>
      <th>მისამართი</th>
      <th>შეკვეთის თარიღი</th>
      <th>პროდუქტები</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let order of orders">
      <td>{{ order.id }}</td>
      <td>{{ order.name }}</td>
      <td>{{ order.phone }}</td>
      <td>{{ order.address }}</td>
      <td>{{ order.created_at | date:'short' }}</td>
      <td>
        <div class="d-flex">
          <button class="btn btn-sm btn-primary" (click)="openItemsModal(order, itemsModal)">ნახვა</button>
          <button class="btn btn-sm text-danger border rounded d-flex align-items-center mx-2" (click)="delete(order.id)"><i class="fi fi-rr-trash"></i></button>
        </div>
      </td>
    </tr>
  </tbody>
</table>

<div *ngIf="!load && !orders.length" class="alert alert-warning">
  შეკვეთები არ მოიძებნა.
</div>

</div>

<ng-template #itemsModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">შეკვეთის დეტალები #{{ selectedOrder?.id }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
    <div class="modal-body" id="order-pdf">
   
    <h2 style="font-size: 16px;">შეკვეთა #{{ selectedOrder?.id }}</h2>
    <p style="font-size: 12px;">სახელი: {{ selectedOrder?.name }}</p>
    <p style="font-size: 12px;">ტელეფონი: {{ selectedOrder?.phone }}</p>
    <p style="font-size: 12px;">მისამართი: {{ selectedOrder?.address }}</p>
    <p style="font-size: 12px;">თარიღი: {{ selectedOrder?.created_at }}</p>

    <table border="1" cellspacing="0" cellpadding="5" style="font-size: 12px; width: 100%;">
        <thead>
        <tr>
            <th>პროდუქტი</th>
            <th>რაოდენობა</th>
            <th>ფასი</th>
            <th>ჯამი</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of selectedOrder?.items">
            <td>{{ item.title_ka }}</td>
            <td>{{ item.quantity }}</td>
            <td>{{ item.price }}</td>
            <td>{{ (item.quantity || 0) * (item.price || 0) }}</td>
        </tr>
        </tbody>
    </table>
    </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">დახურვა</button>
    <button class="btn btn-primary" (click)="printOrderHtml()">PDF-ის გადმოწერა</button>
  </div>
</ng-template>